var mockData = {
  blogArticleListData: [{
    id: '4f0da2a1-0382-5665-be59-eae252731a73',
    title: 'Understanding Pet Food Ingredients',
    featured: true,
    blogCategory: {
      categoryName: 'Pet Food'
    },
    blogContent: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    blogShortDescription: {
      id: 'fc1c9469-0d16-518a-ac78-ee3383047bc7',
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Proin accumsan sapien quis lorem iaculis, vitae tristique quam iaculis. Aliquam in risus mi. Integer faucibus at lectus id molestie',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    blogImage: {
      id: 'c408aa72-c22a-5adb-9c00-b17e96eb2215',
      image: {
        url: '//images.ctfassets.net/rt5zmd3ipxai/29rtscZxalfvh6v5642j2u/54bab6426e7315d884b2b28b021a1061/Blog_Home1.png',
        fileName: 'Blog Home1.png',
        contentType: 'image/png'
      },
      mobileImage: {
        url: '//images.ctfassets.net/rt5zmd3ipxai/29rtscZxalfvh6v5642j2u/54bab6426e7315d884b2b28b021a1061/Blog_Home1.png',
        fileName: 'Blog Home1.png',
        contentType: 'image/png'
      },
      altText: 'Blog Alt'
    }
  }, {
    id: '094848bb-b8f3-53ed-9efb-7569c6b11fb2',
    title: 'Winter Weather Safety Tips for Your Pup',
    featured: true,
    blogCategory: {
      categoryName: 'Pet Care'
    },
    blogContent: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc. Vivamus ut bibendum lacus, vel feugiat ligula. Sed tellus tortor, tempus sed dignissim sed, feugiat maximus sapien. Donec dapibus interdum dui, quis tincidunt tellus volutpat ac.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Maecenas mi urna, efficitur sit amet tellus vel, ornare tincidunt odio. Pellentesque feugiat congue massa, eu iaculis justo viverra eu. Nunc a orci quam. Nulla ut nulla ac purus sodales blandit id ut tortor. Morbi urna sapien, efficitur eu dapibus non, eleifend quis nulla. Morbi ultrices, eros ac vulputate dapibus, mauris sem suscipit dolor, nec cursus nisi velit et justo. Morbi pretium tellus et metus semper, eu maximus nibh bibendum. Nam feugiat orci velit. Mauris mauris augue, tincidunt eget felis ut, laoreet vehicula lectus. Integer pretium lectus urna, id porttitor augue hendrerit nec. Nulla metus urna, porta vitae arcu sit amet, commodo sodales lorem. Praesent id imperdiet libero. Integer in luctus sem, sit amet volutpat lorem. Sed magna augue, elementum vitae nisl eu, malesuada hendrerit nulla. Vestibulum ut magna metus.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Morbi consectetur ullamcorper sodales. Cras tincidunt pulvinar efficitur. Nulla sollicitudin tempus tellus sit amet rhoncus. Sed tempor vehicula turpis, et vulputate sem vulputate vitae. ',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    blogShortDescription: {
      id: 'a42d8929-2f67-52f2-af7e-e7bfac2d82ea',
      json: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Proin accumsan sapien quis lorem iaculis, vitae tristique quam iaculis. Aliquam in risus mi. Integer faucibus at lectus id molestie","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    },
    blogImage: {
      id: '2f33b227-7ae7-506c-941c-e5ccd32c8f96',
      image: {
        url: '//images.ctfassets.net/rt5zmd3ipxai/65d8EFLLRqFVkSoEbnBbmf/d8787f570c95dfa749ef49b40dbd2b14/Blog_Article1.png',
        fileName: 'Blog Article1.png',
        contentType: 'image/png'
      },
      mobileImage: {
        url: '//images.ctfassets.net/rt5zmd3ipxai/65d8EFLLRqFVkSoEbnBbmf/d8787f570c95dfa749ef49b40dbd2b14/Blog_Article1.png',
        fileName: 'Blog Article1.png',
        contentType: 'image/png'
      },
      altText: 'Image Alt'
    }
  }, {
    id: '94fb0ede-0cdd-5a42-8e25-eb600201d63c',
    title: '3 Dietary Changes to Improve Your Dog’s Health',
    featured: false,
    blogCategory: {
      categoryName: 'Dog Care'
    },
    blogContent: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc. Vivamus ut bibendum lacus, vel feugiat ligula. Sed tellus tortor, tempus sed dignissim sed, feugiat maximus sapien. Donec dapibus interdum dui, quis tincidunt tellus volutpat ac. Proin accumsan sapien quis lorem iaculis, vitae tristique quam iaculis. Aliquam in risus mi. Integer faucibus at lectus id molestie. Mauris congue, nunc sit amet congue fermentum, justo elit egestas felis, ut convallis nulla libero in magna.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Maecenas mi urna, efficitur sit amet tellus vel, ornare tincidunt odio. Pellentesque feugiat congue massa, eu iaculis justo viverra eu. Nunc a orci quam. Nulla ut nulla ac purus sodales blandit id ut tortor. Morbi urna sapien, efficitur eu dapibus non, eleifend quis nulla. Morbi ultrices, eros ac vulputate dapibus, mauris sem suscipit dolor, nec cursus nisi velit et justo. Morbi pretium tellus et metus semper, eu maximus nibh bibendum. Nam feugiat orci velit. Mauris mauris augue, tincidunt eget felis ut, laoreet vehicula lectus. Integer pretium lectus urna, id porttitor augue hendrerit nec. Nulla metus urna, porta vitae arcu sit amet, commodo sodales lorem. Praesent id imperdiet libero. Integer in luctus sem, sit amet volutpat lorem. Sed magna augue, elementum vitae nisl eu, malesuada hendrerit nulla. Vestibulum ut magna metus.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    blogShortDescription: {
      id: '42459ef4-bc50-599e-b7d3-7d9bf07dc97c',
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    blogImage: {
      id: '486a1dcd-05e2-553e-93f2-437abcbc7b53',
      image: {
        url: '//images.ctfassets.net/rt5zmd3ipxai/5c3TnmiyFPKBCex2kdYz3l/24eed8b0cced8ae3d9638e484e436dcf/Blog_Article3.png',
        fileName: 'Blog Article3.png',
        contentType: 'image/png'
      },
      mobileImage: {
        url: '//images.ctfassets.net/rt5zmd3ipxai/5c3TnmiyFPKBCex2kdYz3l/24eed8b0cced8ae3d9638e484e436dcf/Blog_Article3.png',
        fileName: 'Blog Article3.png',
        contentType: 'image/png'
      },
      altText: 'Image Alt'
    }
  }],
  imageRenditions: {
    desktopL: {
      w: '338',
      h: '258'
    },
    desktop: {
      w: '338',
      h: '258'
    },
    tabletL: {
      w: '304',
      h: '232'
    },
    tabletP: {
      w: '540',
      h: '390'
    },
    mobile: {
      w: '280',
      h: '202'
    }
  },
  imageRenditionsFeatured: {
    desktopL: {
      w: '338',
      h: '258'
    },
    desktop: {
      w: '338',
      h: '258'
    },
    tabletL: {
      w: '304',
      h: '232'
    },
    tabletP: {
      w: '540',
      h: '390'
    },
    mobile: {
      w: '280',
      h: '202'
    }
  },
  currentPage: 1,
  slugifiedTitle: 'understanding-pet-food-ingredients',
  categoryValues: ['Pet Food', 'Pet Care', 'Dog Care'],
  selectedValue: 'Pet Food',
  categoryFilter: ['Pet Food'],
  limit: 10,
  className: 'test',
  pageRoute: ['blog']
};
var mockDataNewsroom = {
  blogArticleListData: [{
    id: '4f0da2a1-0382-5665-be59-eae252731a73',
    title: 'Understanding Pet Food Ingredients',
    featured: true,
    blogCategory: {
      categoryName: 'Pet Food'
    },
    blogContent: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    blogShortDescription: {
      id: 'fc1c9469-0d16-518a-ac78-ee3383047bc7',
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Proin accumsan sapien quis lorem iaculis, vitae tristique quam iaculis. Aliquam in risus mi. Integer faucibus at lectus id molestie',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    blogImage: {
      id: 'c408aa72-c22a-5adb-9c00-b17e96eb2215',
      image: {
        url: '//images.ctfassets.net/rt5zmd3ipxai/29rtscZxalfvh6v5642j2u/54bab6426e7315d884b2b28b021a1061/Blog_Home1.png',
        fileName: 'Blog Home1.png',
        contentType: 'image/png'
      },
      mobileImage: {
        url: '//images.ctfassets.net/rt5zmd3ipxai/29rtscZxalfvh6v5642j2u/54bab6426e7315d884b2b28b021a1061/Blog_Home1.png',
        fileName: 'Blog Home1.png',
        contentType: 'image/png'
      },
      altText: 'Blog Alt'
    }
  }, {
    id: '094848bb-b8f3-53ed-9efb-7569c6b11fb2',
    title: 'Winter Weather Safety Tips for Your Pup',
    featured: true,
    blogCategory: {
      categoryName: 'Pet Care'
    },
    blogContent: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc. Vivamus ut bibendum lacus, vel feugiat ligula. Sed tellus tortor, tempus sed dignissim sed, feugiat maximus sapien. Donec dapibus interdum dui, quis tincidunt tellus volutpat ac.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Maecenas mi urna, efficitur sit amet tellus vel, ornare tincidunt odio. Pellentesque feugiat congue massa, eu iaculis justo viverra eu. Nunc a orci quam. Nulla ut nulla ac purus sodales blandit id ut tortor. Morbi urna sapien, efficitur eu dapibus non, eleifend quis nulla. Morbi ultrices, eros ac vulputate dapibus, mauris sem suscipit dolor, nec cursus nisi velit et justo. Morbi pretium tellus et metus semper, eu maximus nibh bibendum. Nam feugiat orci velit. Mauris mauris augue, tincidunt eget felis ut, laoreet vehicula lectus. Integer pretium lectus urna, id porttitor augue hendrerit nec. Nulla metus urna, porta vitae arcu sit amet, commodo sodales lorem. Praesent id imperdiet libero. Integer in luctus sem, sit amet volutpat lorem. Sed magna augue, elementum vitae nisl eu, malesuada hendrerit nulla. Vestibulum ut magna metus.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Morbi consectetur ullamcorper sodales. Cras tincidunt pulvinar efficitur. Nulla sollicitudin tempus tellus sit amet rhoncus. Sed tempor vehicula turpis, et vulputate sem vulputate vitae. ',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    blogShortDescription: {
      id: 'a42d8929-2f67-52f2-af7e-e7bfac2d82ea',
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Proin accumsan sapien quis lorem iaculis, vitae tristique quam iaculis. Aliquam in risus mi. Integer faucibus at lectus id molestie',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    blogImage: {
      id: '2f33b227-7ae7-506c-941c-e5ccd32c8f96',
      image: {
        url: '//images.ctfassets.net/rt5zmd3ipxai/65d8EFLLRqFVkSoEbnBbmf/d8787f570c95dfa749ef49b40dbd2b14/Blog_Article1.png',
        fileName: 'Blog Article1.png',
        contentType: 'image/png'
      },
      mobileImage: {
        url: '//images.ctfassets.net/rt5zmd3ipxai/65d8EFLLRqFVkSoEbnBbmf/d8787f570c95dfa749ef49b40dbd2b14/Blog_Article1.png',
        fileName: 'Blog Article1.png',
        contentType: 'image/png'
      },
      altText: 'Image Alt'
    }
  }, {
    id: '94fb0ede-0cdd-5a42-8e25-eb600201d63c',
    title: '3 Dietary Changes to Improve Your Dog’s Health',
    featured: false,
    blogCategory: {
      categoryName: 'Dog Care'
    },
    blogContent: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc. Vivamus ut bibendum lacus, vel feugiat ligula. Sed tellus tortor, tempus sed dignissim sed, feugiat maximus sapien. Donec dapibus interdum dui, quis tincidunt tellus volutpat ac. Proin accumsan sapien quis lorem iaculis, vitae tristique quam iaculis. Aliquam in risus mi. Integer faucibus at lectus id molestie. Mauris congue, nunc sit amet congue fermentum, justo elit egestas felis, ut convallis nulla libero in magna.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Maecenas mi urna, efficitur sit amet tellus vel, ornare tincidunt odio. Pellentesque feugiat congue massa, eu iaculis justo viverra eu. Nunc a orci quam. Nulla ut nulla ac purus sodales blandit id ut tortor. Morbi urna sapien, efficitur eu dapibus non, eleifend quis nulla. Morbi ultrices, eros ac vulputate dapibus, mauris sem suscipit dolor, nec cursus nisi velit et justo. Morbi pretium tellus et metus semper, eu maximus nibh bibendum. Nam feugiat orci velit. Mauris mauris augue, tincidunt eget felis ut, laoreet vehicula lectus. Integer pretium lectus urna, id porttitor augue hendrerit nec. Nulla metus urna, porta vitae arcu sit amet, commodo sodales lorem. Praesent id imperdiet libero. Integer in luctus sem, sit amet volutpat lorem. Sed magna augue, elementum vitae nisl eu, malesuada hendrerit nulla. Vestibulum ut magna metus.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    blogShortDescription: {
      id: '42459ef4-bc50-599e-b7d3-7d9bf07dc97c',
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam iaculis laoreet mauris, eu commodo lacus blandit eu. Maecenas suscipit commodo velit in tincidunt. Donec sollicitudin eget mauris at consectetur. Vestibulum lectus turpis, semper vestibulum facilisis id, placerat volutpat nunc',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    blogImage: {
      id: '486a1dcd-05e2-553e-93f2-437abcbc7b53',
      image: {
        url: '//images.ctfassets.net/rt5zmd3ipxai/5c3TnmiyFPKBCex2kdYz3l/24eed8b0cced8ae3d9638e484e436dcf/Blog_Article3.png',
        fileName: 'Blog Article3.png',
        contentType: 'image/png'
      },
      mobileImage: {
        url: '//images.ctfassets.net/rt5zmd3ipxai/5c3TnmiyFPKBCex2kdYz3l/24eed8b0cced8ae3d9638e484e436dcf/Blog_Article3.png',
        fileName: 'Blog Article3.png',
        contentType: 'image/png'
      },
      altText: 'Image Alt'
    }
  }],
  imageRenditions: {
    desktopL: {
      w: '338',
      h: '258'
    },
    desktop: {
      w: '338',
      h: '258'
    },
    tabletL: {
      w: '304',
      h: '232'
    },
    tabletP: {
      w: '540',
      h: '390'
    },
    mobile: {
      w: '280',
      h: '202'
    }
  },
  imageRenditionsFeatured: {
    desktopL: {
      w: '338',
      h: '258'
    },
    desktop: {
      w: '338',
      h: '258'
    },
    tabletL: {
      w: '304',
      h: '232'
    },
    tabletP: {
      w: '540',
      h: '390'
    },
    mobile: {
      w: '280',
      h: '202'
    }
  },
  currentPage: 1,
  slugifiedTitle: 'understanding-pet-food-ingredients',
  categoryValues: ['Pet Food', 'Pet Care', 'Dog Care'],
  selectedValue: 'Pet Food',
  categoryFilter: ['Pet Food'],
  limit: 10,
  className: 'test',
  pageRoute: ['newsroom']
};
export { mockData, mockDataNewsroom };